import { isNil } from 'lodash'
import { Box } from '@mui/material'
import { useParams } from 'react-router-dom'
import { LocationSweepstakeDetailsHeader } from './LocationSweepstakeDetailsHeader'
import { useGetSweepstakeById } from 'hooks/api/useGetSweepstakeById'
import { LocationSweepstakesDetailsSection } from './LocationSweepstakeDetailsSection'
import { ActivityIndicator } from 'components/Shared/ActivityIndicator'
import { LocationSweepstakeImageSection } from './LocationSweepstakeImageSection'
import { LocationSweepstakeDrawingsSection } from './LocationSweepstakeDrawingsSection'
import { LocationSweepstakeSingleDrawingSection } from './LocationSweepstakeSingleDrawingSection'

export const LocationSweepstakeOverviewPage = () => {
  const { id: idParam } = useParams()
  const sweepstakeId = Number(idParam)
  const sweepstakeQuery = useGetSweepstakeById(sweepstakeId)

  if (sweepstakeQuery.isPending) {
    return <ActivityIndicator />
  }

  if (sweepstakeQuery.isError || isNil(sweepstakeQuery.data)) {
    return <Box>An error occurred fetching the sweepstake.</Box>
  }

  const sweepstake = sweepstakeQuery.data

  return (
    <LocationSweepstakeDetailsHeader
      sweepstake={sweepstake}
      currentTab={`/Contests/LocationSweepstakes/${sweepstake.id}/Overview`}
    >
      <Box>
        <LocationSweepstakesDetailsSection sweepstake={sweepstake} />
        <LocationSweepstakeImageSection sweepstake={sweepstake} />
        {sweepstake.groupId && (
          <LocationSweepstakeDrawingsSection sweepstake={sweepstake} />
        )}
        {!sweepstake.groupId && (
          <LocationSweepstakeSingleDrawingSection sweepstake={sweepstake} />
        )}
      </Box>
    </LocationSweepstakeDetailsHeader>
  )
}
